/**
 * ===== assets/sticky-atc.js =====
 * 懸浮加購條 (Sticky Add to Cart) 控制邏輯
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var stickyBar = document.getElementById('bh-sticky-atc');
    if (!stickyBar) return;

    var productId = stickyBar.getAttribute('data-product-id');
    var mainWrapper = document.getElementById('bh-product-' + productId);
    if (!mainWrapper) return;

    // Get main elements
    var mainAtcBtn = mainWrapper.querySelector('.bh-product-atc-btn') || document.getElementById('bh-atc-btn-' + productId);
    var mainVariantInput = mainWrapper.querySelector('input[name="id"]');
    var mainQtyInput = mainWrapper.querySelector('input[name="quantity"]');
    var mainForm = mainWrapper.querySelector('form[action*="/cart/add"]');

    // Get sticky elements
    var stickySelect = document.getElementById('bh-sticky-atc-variant-select');
    var stickyHiddenInput = document.getElementById('bh-sticky-atc-variant-id');
    var stickyQtyInput = document.getElementById('bh-sticky-atc-qty-input');
    var stickyQtyMinus = document.getElementById('bh-sticky-atc-qty-minus');
    var stickyQtyPlus = document.getElementById('bh-sticky-atc-qty-plus');
    var stickySubmit = document.getElementById('bh-sticky-atc-submit');
    var stickyPrice = document.getElementById('bh-sticky-atc-price');
    var stickyImg = document.getElementById('bh-sticky-atc-img');
    var stickyText = document.getElementById('bh-sticky-atc-text');

    if (!mainAtcBtn) return;

    /* 1. Scroll Detection using IntersectionObserver */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-active');
        } else {
          // Only show when main ATC button has scrolled PAST the top of screen
          if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-active');
          } else {
            stickyBar.classList.remove('is-active');
          }
        }
      });
    }, { root: null, threshold: 0 });

    observer.observe(mainAtcBtn);

    /* 2. Sync Qty Selection Bidirectionally */
    if (mainQtyInput && stickyQtyInput) {
      // Input event listener
      mainQtyInput.addEventListener('input', function () {
        stickyQtyInput.value = mainQtyInput.value;
      });
      stickyQtyInput.addEventListener('input', function () {
        mainQtyInput.value = stickyQtyInput.value;
      });

      // Qty Buttons on Sticky
      if (stickyQtyMinus && stickyQtyPlus) {
        stickyQtyMinus.addEventListener('click', function () {
          var val = parseInt(stickyQtyInput.value, 10) || 1;
          if (val > 1) {
            stickyQtyInput.value = val - 1;
            mainQtyInput.value = val - 1;
          }
        });
        stickyQtyPlus.addEventListener('click', function () {
          var val = parseInt(stickyQtyInput.value, 10) || 1;
          stickyQtyInput.value = val + 1;
          mainQtyInput.value = val + 1;
        });
      }
    }

    /* 3. Sync Variant Selection Bidirectionally */
    // A. Sync from Main swatch click to Sticky Bar
    var mainSwatches = mainWrapper.querySelectorAll('.bh-product-option-swatch');
    mainSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        // Wait briefly for main JS script to finish mapping & updating mainVariantInput.value
        setTimeout(function () {
          if (!mainVariantInput) return;
          var newVariantId = mainVariantInput.value;

          if (stickySelect) {
            stickySelect.value = newVariantId;
            // Trigger meta update
            var activeOption = stickySelect.options[stickySelect.selectedIndex];
            if (activeOption) {
              updateStickyMeta(activeOption);
            }
          } else if (stickyHiddenInput) {
            stickyHiddenInput.value = newVariantId;
          }
        }, 60);
      });
    });

    // B. Sync from Sticky Bar select to Main swatches click
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var selectedId = stickySelect.value;
        var activeOption = stickySelect.options[stickySelect.selectedIndex];
        if (activeOption) {
          updateStickyMeta(activeOption);
        }

        // We find the variant options from product's window variable or extract options
        // For simplicity and compatibility, we check if product data is available
        // But since we just want to match variant selector options, we trigger swatch clicks.
        // The option title is parsed or we match by index.
        // We find the option in Shopify's global product.variants JSON, if exposed.
        // Alternatively, we can let mainVariantInput.value change directly, but triggering swatches is cleaner.
        // Let's query the Shopify option data by querying options inside Shopify's JSON if exposed.
        // If not, we can trigger click on option swatches by mapping their option index and value.
        // Let's inspect the variant title (e.g. "Matte Black / Stitching Red"). It is split by ' / '.
        var variantTitle = activeOption.text.split('-')[0].trim(); // Remove "Sold Out" text if present
        var optionValues = variantTitle.split('/').map(function (str) { return str.trim(); });

        optionValues.forEach(function (val, index) {
          var matchedSwatch = mainWrapper.querySelector('.bh-product-option-swatch[data-option-index="' + index + '"][data-value="' + val.replace(/"/g, '\\"') + '"]');
          if (matchedSwatch) {
            // Click to trigger main theme gallery / price updating
            matchedSwatch.click();
          }
        });
      });
    }

    function updateStickyMeta(optionEl) {
      if (stickyPrice) {
        var price = optionEl.getAttribute('data-price');
        if (price) stickyPrice.textContent = price;
      }
      if (stickyImg) {
        var imgUrl = optionEl.getAttribute('data-image');
        if (imgUrl) stickyImg.src = imgUrl;
      }
      if (stickySubmit && stickyText) {
        var isDisabled = optionEl.disabled;
        stickySubmit.disabled = isDisabled;
        stickyText.textContent = isDisabled ? 'SOLD OUT' : 'ADD TO CART';
      }
    }

    /* 4. Click Submit - Trigger programmatically */
    stickySubmit.addEventListener('click', function (e) {
      e.preventDefault();
      if (mainAtcBtn) {
        mainAtcBtn.click();
      }
    });

    /* 5. Mutation Observer to Sync Main Button States (Loading / Disabled) */
    var observerConfig = { attributes: true, attributeFilter: ['disabled', 'class'] };
    var mainAtcObserver = new MutationObserver(function () {
      stickySubmit.disabled = mainAtcBtn.disabled;
      
      var isMainLoading = mainAtcBtn.classList.contains('is-loading') || mainAtcBtn.textContent.includes('...');
      if (isMainLoading) {
        stickySubmit.classList.add('is-loading');
        stickyText.textContent = 'ADDING...';
      } else {
        stickySubmit.classList.remove('is-loading');
        stickyText.textContent = mainAtcBtn.disabled ? 'SOLD OUT' : 'ADD TO CART';
      }
    });
    
    mainAtcObserver.observe(mainAtcBtn, observerConfig);
  });
})();
